import { createSlice } from '@reduxjs/toolkit';
import { findPropertyFacility, createPropertyFacility, getPropertyFacility } from './api';
import { initialState } from './api/interface';

const propertyFacilitySlice = createSlice({
  name: 'propertyFacility',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findPropertyFacility.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findPropertyFacility.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.totalRecords = action.payload.total;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(findPropertyFacility.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
    builder.addCase(createPropertyFacility.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createPropertyFacility.fulfilled, (state, action) => {
      state.data.push(action.payload);
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
    });
    builder.addCase(createPropertyFacility.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
    });
    builder.addCase(getPropertyFacility.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getPropertyFacility.fulfilled, (state, _) => {
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
    });
    builder.addCase(getPropertyFacility.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
    });
  },
});

export const { setLimit, setSkip, setCurrentPage, setStatus, reset } = propertyFacilitySlice.actions;
export default propertyFacilitySlice.reducer;